import { SkeletonProps, Skeleton as DefaultSkeleton } from "@material-ui/lab";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import * as React from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "rgba(0, 0, 0, 0.28)",
    },
    text: {
      margin: 0,
    },
    GridSkeleton: {
      width: "100%",
      height: "100%",
    },
    InstallationGroupCardSkeleton: {
      minHeight: 400,
      maxWidth: 500,
    },

    InstallationGroupEditMainCardButtonSkeleton: {
      width: 100,
      minHeight: 36,
    },

    InstallationGroupEditAccordionSkeleton: {
      minHeight: 60,
    },

    BlockSkeleton: {
      minHeight: 400,
    },
  })
);

type BaseSkeletonProps = {
  type:
    | "text"
    | "root"
    | "GridSkeleton"
    | "InstallationGroupCardSkeleton"
    | "InstallationGroupEditMainCardButtonSkeleton"
    | "InstallationGroupEditAccordionSkeleton"
    | "BlockSkeleton";
} & SkeletonProps;

// Base augmented Skeleton
function Skeleton(props: BaseSkeletonProps) {
  const classes = useStyles();

  return (
    <DefaultSkeleton
      classes={{ root: classes.root, text: classes.text }}
      className={classes[props.type]}
      {...props}
    />
  );
}

// Specific groups of Skeletons
// export function SpecificSkeleton(props) {
//   remember to add class SpecificSkeleton to makeStyles and type props
//   return <Skeleton type="SpecificSkeleton" />;
// }

export function GridSkeleton() {
  return <Skeleton type="GridSkeleton" />;
}

export function InstallationGroupCardSkeleton() {
  return <Skeleton type="InstallationGroupCardSkeleton" />;
}

export function InstallationGroupEditMainCardButtonSkeleton() {
  return <Skeleton type="InstallationGroupEditMainCardButtonSkeleton" />;
}

export function InstallationGroupEditAccordionSkeleton() {
  return <Skeleton type="InstallationGroupEditAccordionSkeleton" />;
}

export function BlockSkeleton() {
  return <Skeleton type="BlockSkeleton" />;
}
